import { createCrudApi } from '@core/api/createCrudApi';
import type { BaseEntity } from '@core/interfaces';
import axiosInstance from '@core/utils/axiosInstance';

export interface StoleCut extends BaseEntity {
  name: string;
  imagePath: string | null;
  thumbnailPath?: string | null;
  imageWidth?: number | null;
  imageHeight?: number | null;
  sortOrder?: number;
}

export interface CreateStoleCutData {
  vestment: number;
  name: string;
  image?: File;
}

export type UpdateStoleCutData = Partial<CreateStoleCutData>;

const stoleCutApi = createCrudApi<
  StoleCut,
  CreateStoleCutData,
  UpdateStoleCutData
>('stole-cut');

export const deleteStoleCut = stoleCutApi.delete;
export const reorderStoleCuts = (vestmentId: number, ids: number[]) =>
  stoleCutApi.reorder(ids, { vestment: vestmentId });

function buildStoleCutFormData(data: UpdateStoleCutData) {
  const formData = new FormData();
  if (data.vestment !== undefined) {
    formData.append('vestment', String(data.vestment));
  }
  if (data.name !== undefined) {
    formData.append('name', data.name);
  }
  if (data.image) {
    formData.append('image', data.image);
  }
  return formData;
}

export async function createStoleCut(
  data: CreateStoleCutData
): Promise<StoleCut> {
  const formData = buildStoleCutFormData(data);
  const response = await axiosInstance.post('/stole-cut', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
}

export async function updateStoleCut(
  id: number,
  data: UpdateStoleCutData
): Promise<StoleCut> {
  const formData = buildStoleCutFormData(data);
  const response = await axiosInstance.post(`/stole-cut/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
}
